var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionsCount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 28.5C17.713 28.5 21.274 27.025 23.8995 24.3995C26.525 21.774 28 18.213 28 14.5C28 10.787 26.525 7.22601 23.8995 4.60051C21.274 1.975 17.713 0.5 14 0.5C10.287 0.5 6.72601 1.975 4.10051 4.60051C1.475 7.22601 0 10.787 0 14.5C0 18.213 1.475 21.774 4.10051 24.3995C6.72601 27.025 10.287 28.5 14 28.5ZM9.28594 9.53984C9.71797 8.32031 10.8773 7.5 12.1734 7.5H15.3617C17.2703 7.5 18.8125 9.04766 18.8125 10.9508C18.8125 12.1867 18.1508 13.3297 17.0789 13.9477L15.3125 14.9594C15.3016 15.6703 14.7164 16.25 14 16.25C13.2727 16.25 12.6875 15.6648 12.6875 14.9375V14.1992C12.6875 13.7289 12.9391 13.2969 13.3492 13.0617L15.7719 11.6727C16.0289 11.525 16.1875 11.2516 16.1875 10.9563C16.1875 10.4969 15.8156 10.1305 15.3617 10.1305H12.1734C11.9875 10.1305 11.8234 10.2453 11.7633 10.4203L11.7414 10.4859C11.5008 11.1695 10.7461 11.525 10.068 11.2844C9.38984 11.0437 9.02891 10.2891 9.26953 9.61094L9.29141 9.54531L9.28594 9.53984ZM12.25 19.75C12.25 19.2859 12.4344 18.8408 12.7626 18.5126C13.0908 18.1844 13.5359 18 14 18C14.4641 18 14.9092 18.1844 15.2374 18.5126C15.5656 18.8408 15.75 19.2859 15.75 19.75C15.75 20.2141 15.5656 20.6592 15.2374 20.9874C14.9092 21.3156 14.4641 21.5 14 21.5C13.5359 21.5 13.0908 21.3156 12.7626 20.9874C12.4344 20.6592 12.25 20.2141 12.25 19.75Z",
    fill: "url(#paint0_linear_160_4670)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_160_4670",
    x1: 3.04609e-7,
    y1: 2.49999,
    x2: 28.5668,
    y2: 3.24428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD4D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionsCount);
export default __webpack_public_path__ + "static/media/questions_count.94d48e71ca41c7d47bd5319f24b6f83a.svg";
export { ForwardRef as ReactComponent };